import { render, staticRenderFns } from "./opendata.vue?vue&type=template&id=6cf6a2dc&scoped=true"
import script from "./opendata.vue?vue&type=script&lang=js"
export * from "./opendata.vue?vue&type=script&lang=js"
import style0 from "./opendata.vue?vue&type=style&index=0&id=6cf6a2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6a2dc",
  null
  
)

export default component.exports